import React from "react";
import "./MofaTime.css";
const MofaTime = () => {
  return (
    <div className="mofaTimeContainer">
      <h3>Total time does MOFA, UAE take to attest certificates:</h3>
      <p>
        The time period of authentication of documents from MOFA depends on
        various factors such as which is the country it is being acquired for.
        UAE MOFA attestation in Bangalore is one of the most common procedures
        which take around 12 to 15 business days. This time period shall still
        vary because, sometimes, commercial documents may need only 7 to 10 days
        but in cases of educational documents, the time needed may be more than
        15 days.
      </p>
    </div>
  );
};

export default MofaTime;
